import styled from 'styled-components';

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s;
`;

const LazyImage = ({ src, alt, className, ...props }) => {
  return (
    <ImageContainer className={className} {...props}>
      <Image
        src={src}
        alt={alt}
        loading="lazy"
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.parentElement.innerHTML = '<div style="width: 100%; height: 100%; background-color: #e5e5e5; display: flex; align-items: center; justify-content: center; color: #999; font-size: 0.875rem;">Image not available</div>';
        }}
      />
    </ImageContainer>
  );
};

export default LazyImage;
